import { Flex } from 'theme-ui';
import PropTypes from 'prop-types';
import useSiteMetadataQuery from '~/hooks/graphql/queries/use-site-metadata';
import InstagramIcon from '~/assets/images/icons/instagram.svg';
import FacebookIcon from '~/assets/images/icons/facebook.svg';
import TwitterIcon from '~/assets/images/icons/twitter_x.svg';
import TikTokIcon from '~/assets/images/icons/tiktok.svg';
import YoutubeIcon from '~/assets/images/icons/youtube.svg';
import LinkedInIcon from '~/assets/images/icons/linkedin.svg';
import LinkRenderer from '../LinkRenderer';

const SocialLinks = ({ theme, forwardSx, ...props }) => {
  const {
    site: {
      siteMetadata: { social },
    },
  } = useSiteMetadataQuery();
  return (
    <div aria-label="Social networks" sx={{ ...forwardSx }} {...props}>
      <Flex
        as="ul"
        sx={{
          variant: 'list.bare',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          fontWeight: 'medium',
          textTransform: 'uppercase',
          fontSize: 2,
          gap: '4rem',
          a: { cursor: 'pointer', pointerEvents: 'auto', width: 'fit-content', height: 'fit-content' },
          svg: { verticalAlign: 'middle' },
          'svg path': { fill: 'white' },
        }}
      >
        <li>
          <LinkRenderer
            linkType="social"
            locationDetail="footer"
            href={social.facebook}
            title="Facebook"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Facebook"
          >
            <FacebookIcon />
          </LinkRenderer>
        </li>

        <li>
          <LinkRenderer
            linkType="social"
            locationDetail="footer"
            href={social.twitter}
            title="Twitter"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Twitter"
          >
            <TwitterIcon height={24} width={24} />
          </LinkRenderer>
        </li>

        <li>
          <LinkRenderer
            linkType="social"
            locationDetail="footer"
            href={social.instagram}
            title="Instagram"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Instagram"
          >
            <div sx={{ pointerEvents: 'none' }}>
              <InstagramIcon />
            </div>
          </LinkRenderer>
        </li>
        <li>
          <LinkRenderer
            linkType="social"
            locationDetail="footer"
            href={social.tiktok}
            title="TikTok"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="TikTok"
          >
            <TikTokIcon />
          </LinkRenderer>
        </li>
        <li>
          <LinkRenderer
            linkType="social"
            locationDetail="footer"
            href={social.youtube}
            title="YouTube"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="TikTok"
          >
            <YoutubeIcon height={24} width={34} />
          </LinkRenderer>
        </li>
        <li>
          <LinkRenderer
            linkType="social"
            locationDetail="footer"
            href={social.linkedin}
            title="LinkedIn"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="LinkedIn"
          >
            <LinkedInIcon height={24} width={24} />
          </LinkRenderer>
        </li>
      </Flex>
    </div>
  );
};

SocialLinks.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']),
};

SocialLinks.defaultProps = {
  theme: 'light',
};

export default SocialLinks;
